export default "__VITE_ASSET__554d965b__"